import React, { useState, useEffect } from "react";
import "./styles.css";
import axios from "axios";
import useAppData from "@/store/useAppData";
import useRouter from "@/store/useRouter";
import { useShallow } from "zustand/shallow";
import { RouterStoreItemKey } from "@/store/useRouter/types";
import logoAirlines from "./logoAirlines.png"

const Login: React.FC = () => {

    const loggedUser = useAppData(state => state.user);
    const setLoggedUser = useAppData(state => state.setUser);

    const go = useRouter(state => state.go);

    const [showPassword, setShowPassword] = useState(false);
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState<string | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            const user = await checkUser(username, password);
            if (user && user?.length > 0) {

                if (user[0]?.changePassword) {
                    const userData = {...user[0], userrole: user[0]?.userrole?.split("|")[0]};
                    setLoggedUser(userData);
                    go({ key: RouterStoreItemKey.CHANGEPASSWORD });
                } else {
                    //const userName = user[0];
                    const userData = {...user[0], userrole: user[0]?.userrole?.split("|")[0]};
                    setLoggedUser(userData);
                    go({ key: RouterStoreItemKey.SELECTMODULE });
                }
            } else {
                setError("Nesprávné přihlašovací údaje");
            }
        } catch (e) {
            console.error(e);
        }
    };

    useEffect(() => {
        if (!loggedUser || !loggedUser?.name || !loggedUser?.userrole) return;
        go({ key: RouterStoreItemKey.SELECTMODULE });
    }, []);

    const checkUser = async (user: string, pass: string) => {
        try {
            const res = await (
                axios({
                    method: "post",
                    url: "api/user/check",
                    data: {
                        user: user,
                        pass: pass
                    }
                })
            );

            return res.data?.user;

        } catch (err) {
            console.log(err);
            throw err;
        }
    }

    return (
        <div className="login-page">
            <div className="login-logo">
                <img src={logoAirlines} className="login-logo-img" />
                <span className="login-logo-text">Sklad</span>
            </div>

            <div className="login-card">
                <h1 className="login-title">
                    Přihlášení
                </h1>

                <form onSubmit={handleSubmit} className="login-form">
                    <input
                        type="text"
                        className="login-input"
                        placeholder="Uživatel"
                        required
                        value={username}
                        onChange={(e) => setUsername(e.target.value)}
                    />

                    <div className="login-password-wrapper">
                        <input
                            type={showPassword ? "text" : "password"}
                            className="login-input login-input-password"
                            placeholder="Heslo"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <button
                            type="button"
                            className="login-password-toggle"
                            onClick={() => setShowPassword(v => !v)}
                        >
                            <svg className="login-password-icon" viewBox="0 0 24 24">
                                <path d="M12 4.5C6.5 4.5 2.3 8 1 12c1.3 4 5.5 7.5 11 7.5s9.7-3.5 11-7.5c-1.3-4-5.5-7.5-11-7.5zm0 12.5A5 5 0 1 1 12 7a5 5 0 0 1 0 10zm0-2.5a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                            </svg>
                        </button>
                    </div>
                    {error && (
                        <div style={{ color: "red", marginTop: 8 }}>
                            {error}
                        </div>
                    )}

                    {/* <button type="button" className="login-forgot">
                        Zapomněl jsem heslo
                    </button> */}

                    <button type="submit" className="login-submit">
                        Přihlásit se
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;